// Third-party libraries
import type { KeyedMutator, SWRConfiguration } from 'swr';
import useSWR from 'swr';

import type { ErrorCustom } from '@/utils/client';
// Utils/Helpers
import { get } from '@/utils/client';

import type { CaptionRestrictionType } from '@/utils/hooks/swr/scheduler/useSchedulerRestrictions/types/captionRestrictionType';
// Types
import type { SchedulerSchemaValidationType } from '@/utils/hooks/swr/scheduler/useSchedulerRestrictions/types/schemaType';
import type { TitleRestrictionType } from '@/utils/hooks/swr/scheduler/useSchedulerRestrictions/types/titleRestrictionType';

// Constants/Libs
import { SCHEDULER_POST_SPECIFICATIONS } from '@/routes/apiEndpoints';

export type MutateUserType = KeyedMutator<{
    media: SchedulerSchemaValidationType;
    caption: CaptionRestrictionType;
}>;

export type UseSchedulerRestrictionDataType = {
    media: SchedulerSchemaValidationType;
    caption: CaptionRestrictionType;
    title: TitleRestrictionType;
};

const useSchedulerRestrictions = (
    options?: SWRConfiguration<UseSchedulerRestrictionDataType, ErrorCustom>
) => {
    const {
        data,
        mutate: mutateSchedulerSchemaValidation,
        error: schedulerSchemaValidationError,
        isLoading
    } = useSWR<UseSchedulerRestrictionDataType, ErrorCustom>(
        SCHEDULER_POST_SPECIFICATIONS,
        (url) =>
            get<{
                data: UseSchedulerRestrictionDataType;
            }>(url).then((res) => {
                return res.data;
            }),
        {
            shouldRetryOnError: false,
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            ...options
        }
    );

    return {
        schedulerSchemaValidation: data?.media,
        captionRestrictions: data?.caption,
        titleRestrictions: data?.title,
        mutateSchedulerSchemaValidation,
        schedulerSchemaValidationError,
        isLoading
    };
};
export default useSchedulerRestrictions;
